import {
    F1ORDERLIST, //=
    F1_PACKAGE_ON_THE_GO_ORDERLIST, //=
    VIEW_ORDER_TRACKING, //=
} from 'Actions/host';
import {
    GET_TASK_LIST,
    GET_TASK_ASSIGNMENT_CUSTOMER_LIST,
    TASK_COUNT,
    GET_TASK_DETAILS,
    TASK_LIST_SEARCH_FIELD,
    TASK_ASSIGNMENT_CUSTOMER_SEARCH_FIELD,
    GET_CUSTOMER_QUESTION_DETAILS,
    SYS_DICT,
    TASK_DETAIL_MESSAGE_COUNT,
    TASK_DETAIL_ON_KEY_READ,
    SET_FROM_HOST_REPLAY_PAGE,
    SET_FROM_TASK_DETAIL_TO_MESSAGE_LIST_PAGE,
    UPDAT_TASK_MESSAGE_LIST_PAGE_NUM,
} from 'Actions/taskManagement';
import update from 'immutability-helper';
import {F1_PACKAGE_SORT} from 'Utils/constant';

let initialState = {
    taskList: [],
    assignmentCustomerList: [],
    assignmentCustomerListLoaded: false,
    assignmentCustomerAbyss: false,
    taskQuantitys: {},
    taskDetailsData: {},
    customerQuestionDetailsData: {},
    closenessList: [],
    taskDetailMessageCount: {},
    onKeyReadMessage: {},
    fromHostReplayPage: false,
    fromTaskDetailToMessageListPageFlag: false,
    currentTaskMessageListPageNum: 0,

    F1OrderList: [], //=
    F1PackageOnTheGoList: [], //=
    viewOrderTrackingData: {}, //=
    taskListSearchfields: {
        queryKey: '',
    },
    taskAssignmentSearchfields: {
        queryKey: '',
    },

    f1OngoPackageIsAsc: F1_PACKAGE_SORT.ASC_SORT,
};

export function taskManagement(state = initialState, action) {
    let payload = {};
    switch (action.type) {
        case GET_TASK_LIST: //=
            if (action.payload.pageNum <= 1) {
                payload.taskList = action.payload.data;
            } else {
                payload.taskList = state.taskList.concat(action.payload.data);
            }
            return {...state, ...payload};

        case GET_TASK_ASSIGNMENT_CUSTOMER_LIST: //=
            if (action.payload.pageNum <= 1) {
                payload.assignmentCustomerList = action.payload.data;
            } else {
                payload.assignmentCustomerList = state.assignmentCustomerList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};

        case TASK_COUNT:
            payload.taskQuantitys = {};
            payload.taskQuantitys = action.payload;
            return {...state, ...payload};

        case GET_TASK_DETAILS:
            payload.taskDetailsData = action.payload;
            return {...state, ...payload};

        case GET_CUSTOMER_QUESTION_DETAILS:
            payload.customerQuestionDetailsData = action.payload;
            return {...state, ...payload};

        case TASK_LIST_SEARCH_FIELD:
            return update(state, {taskListSearchfields: action.payload});

        case TASK_ASSIGNMENT_CUSTOMER_SEARCH_FIELD:
            return update(state, {taskAssignmentSearchfields: action.payload});

        case SYS_DICT:
            payload = action.payload.data;
            return Object.assign({}, state, {closenessList: payload});

        case TASK_DETAIL_MESSAGE_COUNT:
            payload.taskDetailMessageCount = action.payload;
            return {...state, ...payload};

        case TASK_DETAIL_ON_KEY_READ:
            payload.onKeyReadMessage = action.payload;
            return {...state, ...payload};

        case SET_FROM_HOST_REPLAY_PAGE:
            return update(state, {fromHostReplayPage: action.payload});

        case SET_FROM_TASK_DETAIL_TO_MESSAGE_LIST_PAGE:
            return update(state, {
                fromTaskDetailToMessageListPageFlag: action.payload,
            });

        case UPDAT_TASK_MESSAGE_LIST_PAGE_NUM:
            return update(state, {
                currentTaskMessageListPageNum: action.payload,
            });

        case F1ORDERLIST: //=
            if (action.payload.pageNum <= 1) {
                payload.F1OrderList = action.payload.data;
            } else {
                payload.F1OrderList = state.F1OrderList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};

        case F1_PACKAGE_ON_THE_GO_ORDERLIST: //=
            if (action.payload.pageNum <= 1) {
                payload.F1PackageOnTheGoList = action.payload.data;
            } else {
                payload.F1PackageOnTheGoList = state.F1PackageOnTheGoList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};

        case VIEW_ORDER_TRACKING: //=
            payload.viewOrderTrackingData = action.payload;
            return {...state, ...payload};
        default:
            return state;
    }
}
